export function roundFloatToDecimalPlaces(value: number, decimalPlaces: number): number {
  return Number(value.toFixed(decimalPlaces))
}

export const NUM_DECIMALS_ROUND_FLOATS = 9
